"use client"

import { Component } from 'react';
import { IBaseComponentProps } from '../props/IBaseComponentProps';
import { NSFilterItem } from './NSFilterItem';
import { FilterItem } from 'namirasoft-core';
import { NSButton } from './NSButton';
import Styles from './NSFilterBoxItems.module.css';

export interface NSFilterBoxItemsProps extends IBaseComponentProps
{
	filterItems: FilterItem[];
	onClearFilterItems: () => void;
	onRemoveFilterItem: (item: FilterItem) => void;
}
export class NSFilterBoxItems extends Component<NSFilterBoxItemsProps>
{
	override render()
	{
		return <>
			{
				this.props.filterItems.length > 0 &&
				<div className={Styles.ns_filter_box_item}
				>
					<>
						<NSButton
							title={'Clear Filter' + (this.props.filterItems.length > 1 ? "s" : "")}
							onClick={{
								action: () =>
								{
									this.props.onClearFilterItems();
								},
								showLoading: false
							}}
							style={{ width: "136px", border: "2px solid #001664" }}
						/>
						<div className={Styles.ns_filter_box_item_selected_list_parent}>
							{
								this.props.filterItems.map((item, index) =>
									<NSFilterItem
										item={item}
										key={`NSFilterBoxItems_NSFilterItem_key_${index}`}
										removeSelected={() => this.props.onRemoveFilterItem(item)}
									/>
								)
							}
						</div>
					</>
				</div>
			}
		</>
	}
}